var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog",
      attrs: {
        "append-to-body": "",
        "destroy-on-close": "",
        visible: _vm.visible,
        title: _vm.dialogTitle,
        width: "80%",
      },
      on: {
        close: function ($event) {
          return _vm.$emit("update:visible", false)
        },
        closed: function ($event) {
          return _vm.$emit("closed")
        },
      },
    },
    [
      _c(
        "div",
        { staticStyle: { height: "540px" } },
        [
          _c("SchemaTablePage", {
            ref: "tablePageRef",
            attrs: {
              "layout-mode": "dialog",
              immediate: false,
              "search-schema": _vm.searchSchema,
              columns: _vm.tableColumns,
              "table-attrs": _vm.tableAttrs,
              "default-query": _vm.defaultQuery,
              request: _vm.request,
              "build-params": _vm.buildParams,
              "parse-result": _vm.parseResult,
            },
            scopedSlots: _vm._u([
              {
                key: "search-account",
                fn: function ({ query }) {
                  return [
                    _c("el-input", {
                      attrs: {
                        placeholder:
                          query.accountType === "uid"
                            ? "输入代理ID"
                            : "输入代理账号",
                        inputmode:
                          query.accountType === "uid" ? "numeric" : "text",
                        maxlength: "20",
                        clearable: "",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onAccountInput(query, $event)
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "prepend",
                            fn: function () {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100px" },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onAccountTypeChange(
                                          query,
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value: query.accountType,
                                      callback: function ($$v) {
                                        _vm.$set(query, "accountType", $$v)
                                      },
                                      expression: "query.accountType",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: "代理账号",
                                        value: "username",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "代理ID", value: "uid" },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: query.accountValue,
                        callback: function ($$v) {
                          _vm.$set(query, "accountValue", $$v)
                        },
                        expression: "query.accountValue",
                      },
                    }),
                  ]
                },
              },
              {
                key: "username",
                fn: function ({ row }) {
                  return [
                    _c("div", [_vm._v(" " + _vm._s(row.username) + " ")]),
                    _c("span", [_vm._v(" " + _vm._s(row.uid) + " ")]),
                  ]
                },
              },
              {
                key: "agentBackGold",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("centsToYuan")(row.agent_back_gold)) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "totalPayinAmount",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("centsToYuan")(row.total_payin_amount)) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "totalBetAmount",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("centsToYuan")(row.total_bet_amount)) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "shareOneGoldToInviter",
                fn: function ({ row }) {
                  return [
                    _vm.type === "direct"
                      ? _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("centsToYuan")(
                                  row.share_one_gold_to_inviter
                                )
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                    _vm.type === "indirect"
                      ? _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("centsToYuan")(
                                  row.share_two_gold_to_inviter
                                )
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "createdAt",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm._f("formatTime")(row.created_at)) + " "
                    ),
                  ]
                },
              },
              {
                key: "loginAt",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm._f("formatTime")(row.login_at)) + " "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }